// extracted by mini-css-extract-plugin
export default {"footer":"index_footer_iZYpW","foot_link":"index_foot_link_Ahn0j","list":"index_list_hREEz","link":"index_link_jNhjo","copyright":"index_copyright_HAjRL"};